export default function({ $axios, $cookies, app, route, redirect }, inject) {
  $axios.onRequest((config) => {
    $axios.setHeader('X-LANG', app.$cookies.get('lang') || app.i18n.fallbackLocale)

    // Identify tracking and order requests
    const url = config.url
    const isBanners = url === '/banners'
    const isProductDetail = url.startsWith('/products/') && !url.includes('/search') && !url.includes('/recommended-by-category')
    const isCategoryRequest = url.startsWith('/category/') && !url.includes('/search') && !url.includes('/outstanding')
    const isOrderRequest = url.includes('/orders') || url.includes('/quick-orders')
    const isSettingRequest = url === '/setting'

    const isTrackingRequest = isBanners || isProductDetail || isCategoryRequest

    // Prioritize aff from URL query
    let affCode = route.query.aff

    // If not in URL, use cookie for order or setting requests
    if (!affCode && (isOrderRequest || isSettingRequest)) {
      affCode = app.$cookies.get('aff_code')
    }

    // Only inject aff_code for tracking, order or setting requests
    if (affCode && (isTrackingRequest || isOrderRequest || isSettingRequest)) {
      if (config.method === 'get') {
        config.params = config.params || {}
        config.params.aff_code = affCode
        // Remove duplicate 'aff' if it exists in params (often spread from route.query)
        if (config.params.aff) {
          delete config.params.aff
        }
      } else if (['post', 'put', 'patch'].includes(config.method)) {
        if (config.data instanceof FormData) {
          if (!config.data.has('aff_code')) {
            config.data.append('aff_code', affCode)
          }
        } else {
          config.data = config.data || {}
          config.data.aff_code = affCode
        }
      }
    }
  })

  $axios.onError((error) => {
    if (error.response && error.response.status === 403) {
      redirect('/403')
    }
  })
}
